import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./index.css";
import "./Services/i18n";
import i18n from "./Services/i18n";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <CookiesProvider>
      <App />
      <ToastContainer
        position="top-center"
        // The sticky TopBar sits at z-1000001; toastify defaults to 9999, so
        // toasts were rendering behind it. Sit above it and clear its 4.5rem
        // height so the toast never covers the logos.
        style={{
          whiteSpace: "nowrap",
          width: "auto",
          zIndex: 1000002,
          top: "5rem",
        }}
      />
    </CookiesProvider>
  </QueryClientProvider>
);

// Listen to language changes and adjust `dir` dynamically
i18n.on("languageChanged", (lng) => {
  const htmlElement = document.documentElement;
  htmlElement.lang = lng;
  htmlElement.dir = lng === "ar" ? "rtl" : "ltr"; // Set `dir` based on the language
});
